import APPRouter from "./routes/Router";
import ThemeProvider from "components/atoms/Theme/Theme";
import { ToastContainer } from "react-toastify";
import { AppContextProvider } from "utils/context/AppContext";
import "react-datepicker/dist/react-datepicker.css";
import "./App.scss";

function App() {
  return (
    <AppContextProvider>
      <ThemeProvider className="App">
        <APPRouter />
        <ToastContainer position="top-right" />
      </ThemeProvider>
    </AppContextProvider>
  );
}
export default App;